'use strict';

const React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    const n = Object.create(null, { [Symbol.toStringTag]: { value: 'Module' } });
    if (e) {
        for (const k in e) {
            if (k !== 'default') {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: () => e[k]
                });
            }
        }
    }
    n.default = e;
    return Object.freeze(n);
}

const React__namespace = /*#__PURE__*/_interopNamespace(React);

const SvgMiscMicFill = (props) => React__namespace.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "M16 5.91c0-2.21-1.79-4-4-4s-4 1.79-4 4v9h8v-9Z" }),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "M18 10.91v3.76c0 1.23-1 2.24-2.24 2.24H8.24C7 16.91 6 15.91 6 14.67v-3.76H4v3.76c0 2.34 1.9 4.24 4.24 4.24H11v3h2v-3h2.76c2.34 0 4.24-1.9 4.24-4.24v-3.76h-2Z" })
);

module.exports = SvgMiscMicFill;
//# sourceMappingURL=MiscMicFill.cjs.js.map
